import { hasAnalyticsConsent } from './consent';
import { GA4_MEASUREMENT_ID } from './config';
import { pushEvent } from './dataLayer';
import { getMatchingConversions } from './goals';

let gtagInitialized = false;
let gtagScriptRequested = false;

function getMeasurementId() {
  return GA4_MEASUREMENT_ID;
}

function canSendToGtag() {
  return hasAnalyticsConsent() && Boolean(getMeasurementId());
}

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function loadGtagScript(measurementId) {
  if (gtagScriptRequested) return;
  gtagScriptRequested = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

export function initGtag() {
  if (gtagInitialized || !canSendToGtag()) {
    return false;
  }

  const measurementId = getMeasurementId();

  try {
    ensureGtagStub();
    loadGtagScript(measurementId);
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      send_page_view: false,
      anonymize_ip: true,
    });
    gtagInitialized = true;
    return true;
  } catch (error) {
    return false;
  }
}

export function trackPageView(params = {}) {
  if (!canSendToGtag()) {
    return;
  }

  initGtag();

  const pageParams = {
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search + window.location.hash,
    page_title: document.title,
    ...params,
  };

  pushEvent({ event: 'page_view', ...pageParams });

  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', pageParams);
  }
}

export function trackEvent(eventName, params = {}, options = {}) {
  const { trackConversions = true } = options;

  try {
    pushEvent({ event: eventName, ...params });

    if (!hasAnalyticsConsent()) {
      return;
    }

    if (!canSendToGtag()) {
      return;
    }

    initGtag();

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    if (trackConversions) {
      getMatchingConversions(eventName, params).forEach((conversionName) => {
        trackEvent(
          conversionName,
          {
            conversion_source_event: eventName,
            ...params,
          },
          { trackConversions: false }
        );
      });
    }
  } catch (error) {
    // Analytics must never break the site.
  }
}

export function isGtagInitialized() {
  return gtagInitialized;
}
